import React from "react";
import Layout from "../components/layout.js";
import ArticleCoverData from "../components/articlecover.js";

const CollegePage = () => {
  return (
    <div className="CollegePage">
      <Layout>
        <div className="Article">
          <ArticleCoverData />
          <div className="main">
            <div className="content">
              <h4>The Product</h4>
              <p>
                In the context of a website used by millions of US high school
                students to decide where to apply to college, my small team and
                I designed a complete overhaul of the existing tool to help
                students’ expand their horizons and improve their chances of
                attending a college that will allow them to pursue their goals,
                have a rewarding, formative experience, and avoid risking their
                long-term financial security.
              </p>
              <p>
                On my team, we aim to optimize the experiences we design
                particularly for low-income students, students of color, rural
                students, and students whose families, communities, and support
                systems have less familiarity with norms around American higher
                education—the ways colleges differ from one another, the
                structure of payment, the risk of debt, and the assessment of
                value for money, among other factors.
              </p>
              <h4>My Role: UX Design</h4>
              <p>
                As a product designer on the College and Career Access team at
                College Board, my work is focused on building and improving the
                usability of online tools and resources that can help students
                make more informed decisions as they approach the transition
                from high school to college. How to improve their odds of
                getting in, how to apply, how to determine colleges that would
                be a good fit, how to get financial assistance, how to compare
                their options, what to expect when they get there, and more.
              </p>
              <p>
              Through identifying clear principles and goals, and conducting research to better understand the needs and behavior of a wide variety of students coming from different backgrounds, levels of information, preferences, and aspirations, we designed a low-stress experience that makes it easy for students with different needs to discover, explore, and keep track of colleges with traits that are personally important to them, and to compare those colleges based on metrics related to education quality and financial risk. 
              </p>
              </div>


<img src="https://res.cloudinary.com/juleon/image/upload/v1612160290/College_Search_-_Pieces.png" alt="The constituent parts of our solution include filters, college results, and some form of navigation around the results." />

  <img src="https://res.cloudinary.com/juleon/image/upload/v1612160865/student-variety-needs.png" alt="Students had a wide variety of things they knew they wanted or thought they wanted when searching for colleges"/>


  <img src="https://res.cloudinary.com/juleon/image/upload/v1612302569/CollegeFiltersByHowMuchTheyAffectCosts.png" alt="Wireframing filter options and organizing them based on the kinds of financial risks and burdens different factors of colleges impose on students"/>

  <img src="https://res.cloudinary.com/juleon/image/upload/v1612161209/CollegeCostsComparisonIncomeBased.png" alt="Is Amherst or Ohio State more affordable? It depends on your financial situation, how much financial aid you'll be likely to get at each college."/>

  
  <div className="content">
</div>
<div className="content">
              <p>This new design is the result of iterative problem-solving over several rounds of moderated prototype testing, conducted remotely with high school students across the country in-context in their everyday home and school environments.</p> 
              <p>The new design prioritizes helping students’ feel more confident and in control, meeting them where they are, lowering the stakes to experiment and get ideas about the possibilities and consider what might be important to them in a college, making it simple to browse through and meaningfully compare college results, clarifying the information most often misunderstood and most likely to be useful to students with less access to other guidance.</p> 
              </div>
              <img src="https://res.cloudinary.com/juleon/image/upload/v1613273388/CollegeSearch-Experience-Summary3.png" alt="Screens showing the UI of the solution we developed"/>

              <div className="content">
              <p>The new design helps all students get accurate, easy-to-understand visibility into the personal financial implications of different possible options in a way that was not possible before.</p>
            </div>
            <img src="https://res.cloudinary.com/juleon/image/upload/v1612161097/CollegeSearchResultCard-CostAsARange.png" alt="college search result card with cost represented as a range"></img>
            <div className="content"><p>Rather than represent college cost as a static fixed price, we wanted to help debunk that understanding, so we designed an interaction that trains students to select a proxy for their financial situation – a broad approximate range of household income – to receive an individualized cost estimate. This appears right on the card so when students are scrolling through their college results, they can easily compare cost estimates for each college that are much more accurate than the typical metrics used for college cost.</p></div>
            <img src="https://res.cloudinary.com/juleon/image/upload/v1612302676/PersonalizingCollegeCostFromRangeInteraction.png" alt="Students can see the college search results with cost represented in the form of a range. There is a link on the card that students can click that says 'Enter your household income' and they will be prompted to put in a household income range. The results will load again showing a personalized cost estimate for each college, based on that household income ballpark."/>
            </div>
          </div>
       
      </Layout>
    </div>
  );
};

export default CollegePage;
